var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalisedrecommendation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D8EAF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.6313L15.25 16L16.8813 15.25L15.25 14.5L14.5 12.8688L13.75 14.5L12.1188 15.25L13.75 16L14.5 17.6313V17.6313M14.5 21.25L12.625 17.125L8.5 15.25L12.625 13.375L14.5 9.25L16.375 13.375L20.5 15.25L16.375 17.125L14.5 21.25V21.25M20.5 22.75L19.5625 20.6875L17.5 19.75L19.5625 18.8125L20.5 16.75L21.4375 18.8125L23.5 19.75L21.4375 20.6875L20.5 22.75V22.75M14.5 15.25V15.25V15.25V15.25V15.25V15.25V15.25V15.25V15.25V15.25",
    fill: "#004276"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalisedrecommendation);
export default __webpack_public_path__ + "static/media/personalised recommendation.6897564dff6d2c643786543bd5d18d41.svg";
export { ForwardRef as ReactComponent };